// TranslatedText.jsx
import React from "react";
import { useTranslation } from "react-i18next";

const TranslatedText = ({ i18nKey }) => {
  const { t } = useTranslation();
  return <>{t(i18nKey)}</>
};

export default TranslatedText;
